import { useExternalMedia } from "../../../../hooks/useExternalMedia";



const CarouselData = () => {

  const {
    upriseFeedbackImg,
    feedbackImg,
    lewisDeniseFeedbackImg
  } = useExternalMedia();

  const carouselItems = [
    {
      id: 1,
      imgSrc: feedbackImg,
      caption: "Mike Bempah",
      description:
        `"Eratek's HR technology solutions streamlined our processes and improved employee engagement. Their expertise in optimising HR systems helped us retain top talent and drive performance. I strongly recommend Eratek for any African business looking to elevate their HR function through technology."`,
    },
    {
      id: 2,
      imgSrc: lewisDeniseFeedbackImg,
      caption: "Denise Lewis",
      description:
        `"I want to thank the team for guiding me through establishing my website and social media presence. I'm grateful for all the help and support provided by the team. I'm now able to proudly move forward with my business knowing of business has a professional presence."`,
    },
    {
      id: 3,
      imgSrc: upriseFeedbackImg,
      caption: "David Adekunle",
      description:
        `"Solid team who understood what I was looking for"`,
    },
  ];
  return carouselItems
}

export default CarouselData